// extracted by mini-css-extract-plugin
export default {"home":"Exams_home__teo2t","home2":"Exams_home2__4hT6m","main":"Exams_main__nQ3MK"};